
export default function Reviews() {
  const reviews = [
    {
      name: 'Sarah M.',
      rating: 5,
      text: 'Carlos and his team did an amazing job clearing out my garage. They were professional, fast, and very reasonably priced. Highly recommend HAUL IT ALL!',
      date: 'January 2025',
      initials: 'SM'
    },
    {
      name: 'Michael R.',
      rating: 5,
      text: 'Needed same-day service for an eviction cleanout. Carlos came through and got everything done quickly. Very reliable and trustworthy service.',
      date: 'December 2024',
      initials: 'MR'
    },
    {
      name: 'Jennifer L.',
      rating: 4,
      text: 'Great service! They hauled away all my old furniture and appliances. The pricing was fair and they were very careful not to damage anything.',
      date: 'December 2024',
      initials: 'JL'
    },
    {
      name: 'David K.',
      rating: 5,
      text: 'Carlos is the best! He helped us clean out our storage unit and even donated items we didn\'t need. Very professional and friendly.',
      date: 'November 2024',
      initials: 'DK'
    },
    {
      name: 'Lisa P.',
      rating: 5,
      text: 'Excellent service from start to finish. Carlos was responsive, showed up on time, and did a thorough job. Will definitely use again!',
      date: 'November 2024',
      initials: 'LP'
    },
    {
      name: 'Robert T.',
      rating: 4,
      text: 'Very satisfied with the service. They cleared out years of accumulated junk from my property. Fair pricing and hard workers.',
      date: 'October 2024',
      initials: 'RT'
    }
  ];

  return (
    <section id="reviews" className="py-24 bg-gradient-to-b from-black via-gray-900 to-black relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(6, 182, 212, 0.3) 1px, transparent 0)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>
      <div className="absolute top-1/2 right-0 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 text-cyan-400 text-sm font-bold tracking-[0.3em] uppercase mb-4" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
            <span className="w-8 h-px bg-cyan-400"></span>
            Testimonials
            <span className="w-8 h-px bg-cyan-400"></span>
          </span>
          <h2 
            className="text-4xl md:text-5xl font-black text-white mb-4"
            style={{ fontFamily: 'Orbitron, sans-serif' }}
          >
            CUSTOMER <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">REVIEWS</span>
          </h2>
          <p className="text-xl text-gray-400" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
            What our clients are saying about us
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="group bg-gray-800/30 border border-gray-700 hover:border-cyan-500/50 rounded-lg p-6 transition-all duration-500"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-lg flex items-center justify-center text-white font-bold shadow-lg" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                  {review.initials}
                </div>
                <div>
                  <h4 className="font-bold text-white" style={{ fontFamily: 'Rajdhani, sans-serif' }}>{review.name}</h4>
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`ri-star-fill text-sm ${
                          i < review.rating ? 'text-cyan-400' : 'text-gray-600'
                        }`}
                      ></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-gray-400 mb-4 leading-relaxed text-sm">&quot;{review.text}&quot;</p>
              <div className="flex items-center justify-between text-xs text-gray-500">
                <span className="flex items-center gap-1">
                  <i className="ri-facebook-fill text-blue-500"></i>
                  via Facebook
                </span>
                <span>{review.date}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="https://www.facebook.com/marketplace/item/898128335908613/?mibextid=6ojiHh"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-8 py-4 rounded-md text-lg font-bold tracking-wider hover:from-cyan-400 hover:to-blue-500 transition-all duration-300 shadow-lg shadow-cyan-500/30 hover:shadow-cyan-500/50 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: 'Rajdhani, sans-serif' }}
          >
            <i className="ri-facebook-fill text-xl"></i>
            READ MORE ON FACEBOOK
            <i className="ri-external-link-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
